import { createFileRoute } from "@tanstack/react-router"
import { BulkUpdatesOverview } from "@/features/change-projects/components/BulkUpdatesOverview"

export const Route = createFileRoute("/(authenticated)/bulk-updates/")({
  component: BulkUpdatesOverview,
})
